<!--EChart图表组件-->
<template>
  <div :id="chartid" class="default-chart"></div>
</template>
<script>
export default {
  components: {},
  props: {
    themes: undefined, //主题，默认从皮肤配置中获取
  },
  data() {
    return {
      chartid: randomPkid(),
      mychart: {},
      options: {},
      chartBody: undefined,
      bg: "",
    };
  },
  created() {},
  mounted() {
    var text = localStorage.getItem("themeName");
    if (text == "科技蓝") {
      this.bg = "#21577d";
    } else if (text == "活力紫") {
      this.bg = "#3e457f";
    } else if (text == "国网绿") {
      this.bg = "#0a433f";
    } else if (text == "经典黑") {
      this.bg = "#3f414f";
    } else if (text == "天空蓝") {
      this.bg = "#0f2e5b";
    }
    //初始化页面
    this.chartBody = document.getElementById(this.chartid);
    if (this.themes != undefined) {
      this.mychart = echarts.init(this.chartBody, this.themes, {
        renderer: "canves",
      });
    } else {
      this.mychart = echarts.init(this.chartBody, this.nowEchartSkin, {
        renderer: "canves",
      });
    }
    this.mychart.on("click", (params) => {
      this.$emit("itemselect", params);
    });
    //图例切换事件
    this.mychart.on("legendselectchanged", (params) => {
      this.$emit("itemchanged", params);
    });
    //类型切换事件
    this.mychart.on("magictypechanged", (params) => {
      this.$emit("typechanged", params);
    });
    var lastWidth = 0;
    addNewTask(this.chartid, 10, 500, -1, () => {
      if (lastWidth != this.chartBody.offsetWidth) {
        lastWidth = this.chartBody.offsetWidth;
        this.mychart.resize();
      }
    });
    if (this.mychart) {
      this.mychart.resize();
    }
  },
  updated() {
    if (this.mychart) {
      this.mychart.resize();
    }
  },
  beforeDestroy() {
    this.mychart.clear();
  },
  destroyed() {
    if (this.mychart) {
      this.mychart.resize();
    }
    removeTask(this.chartid);
  },
  computed: {
    nowEchartSkin() {
      var nowSkin = this.$store.resourcesStore.state.nowSkinObject;
      if (nowSkin != undefined) {
        return nowSkin.skinTag;
      }
      return;
    },
  },
  watch: {},
  methods: {
    resize() {
      if (this.mychart) {
        this.mychart.resize();
      }
    },
    getOption() {
      return this.mychart.getOption();
    },
    showLoading() {
      this.mychart.showLoading({
        text: "loading",
        color: "#c23531",
        textColor: "#000",
        maskColor: "rgba(255, 255, 255, 0.2)",
        zlevel: 0,
      });
    },
    hideLoading() {
      this.mychart.hideLoading();
    },
    setData(options, shouldClear) {
      this.options = options;
      if (shouldClear == true) {
        this.mychart.setOption(options, true);
        return;
      }

      // console.log("数据",options);
      options.series.forEach((item) => {
        if (item.areaStyle) {
          item.areaStyle.color = this.bg;
        }
      });
      this.mychart.setOption(options);
    },
    getOptions() {
      return this.options;
    },
    getDefaultOptions() {
      return {
        title: {
          text: "数据曲线",
          left: "left",
          textStyle: {
            fontSize: 16,
            fontWeight: "normal",
            color: "#1a1a1a",
          },
        },
        toolbox: {
          show: true,
          showTitle: true, // 隐藏默认文字，否则两者位置会重叠
          right: "3%",
          top: "5%",
          feature: {
            magicType: {
              type: ["line", "bar", "stack", "tiled"],
              title: {
                line: "切换为折线图",
                bar: "切换为柱状图",
                stack: "切换为堆叠",
                tiled: "切换为平铺",
              },
            },
            saveAsImage: {
              show: true,
              title: "下载图片",
            },
            // dataView: { show: true, readOnly: true, lang: ['', '关闭'] },
          },
          tooltip: {
            // 和 option.tooltip 的配置项相同
            show: true,
            formatter: function(param) {
              return "<div>" + param.title + "</div>"; // 自定义的 DOM 结构
            },
            backgroundColor: "#fff",
            textStyle: {
              fontSize: 12,
            },
            extraCssText: "box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);", // 自定义的 CSS 样式
          },
        },

        tooltip: {
          trigger: "axis",
          confine: true,
          formatter: (params, ticket, callback) => {
            var label = params[0].data[0] + "</br>";
            if (params[0].axisType == "xAxis.time") {
              //时间类型
              label = new Date(params[0].data[0]).formatByTime() + "</br>";
            }

            params.forEach((item) => {
              var values;
              if (isnull(item.data[1])) {
                values = "无采集数据";
              } else {
                values = cutDigital(item.data[1]);
              }
              label += item.seriesName + " : " + values + "</br>";
            });
            return label;
          },
          axisPointer: {
            animation: true,
          },
        },
        xAxis: {
          type: "category",
        },
        yAxis: {
          type: "value",
          max: (value) => {
            var max = parseFloat(value.max);
            if (max < 1) {
              return 1;
            }
            if (max < 100) {
              return parseInt(value.max) + 1;
            }
            return parseInt(max * 1.1);
          },
          boundaryGap: [0, "100%"],
          splitLine: {
            show: false,
          },
        },
        dataZoom: [
          {
            type: "inside",
            start: 0,
            end: 100,
          },
        ],
        grid: {
          left: "5%",
          right: "2%",
          bottom: "50",
          containLabel: true,
        },
        legend: {
          data: [],
          type: "scroll",
          bottom: "20px",
          formatter: function(name) {
            return echarts.format.truncateText(
              name,
              100,
              "14px Microsoft Yahei",
              "…"
            );
          },
          tooltip: {
            show: true,
          },
          selected: {},
        },
        series: [
          {
            data: [10, 22, 28, 23, 19],
            type: "line",
            smooth: true,
          },
        ],
      };
    },
  },
};
</script>

<style scoped>
.default-chart {
  width: 100%;
  height: 6rem;
}
</style>
